<template>
    <div class="must-have-exactly-one-root-element">

        <!-- Header -->
        <header-profil
            @updateProfil="emitUpdateProfil"
            :profil="profil"
        />

        <!--<div class="o-registerInfo d-md-flex align-items-center d-none mr-4">
            <div class="m-registerInfo__description d-none d-lg-block">
                <p class="mb-0">Ako to funguje?</p>
            </div>
            <div class="m-registerInfo__btn ml-3">
                <a target="_blank" href="https://adoptujkravicku.sk/pravidla-pouzivania/" class="btn --primary">Pravidlá hry</a>
            </div>
        </div>-->

        <!-- Main -->
        <main class="registerScreen">
            <div class="container-fluid">
                <div class="row --mainRow">
                    <div class="col-xs-12 col-md-4 col-lg-4 col-xl-6 d-none d-xl-block --loginBg leftCol"></div>

                    <!-- Adopcia -->
                    <div class="col-xs-12 col-md-12 col-lg-12 col-xl-6 rightCol">

                        <!-- Breadcrumb -->
                        <ol class="m-stepNavigation">
                            <li class="a-stepNavigation__item is-done mb-2 mb-md-0">VÝBER KRAVIČKY</li>
                            <li class="a-stepNavigation__item is-active mb-2 mb-md-0">ÚDAJE KRAVIČKY</li>
                            <li class="a-stepNavigation__item">EAN KÓDY</li>
                        </ol>

                        <div class="paddingBox">
                            <h2>Údaje kravičky na adopciu</h2>

                            <!-- Alert box -->
                            <div v-if="responseText != ''" :class="'alert alert-'+responseType" role="alert">
                                <span :class="'icon --'+responseType"></span>{{ responseText }}
                            </div>

                            <div class="row">
                                <div class="col-lg-7 col-xl-7">

                                    <!-- Form Box -->
                                    <form @submit="formSubmit">
                                        <div class="form-row">
                                            <div class="col-12 col-md-12">
                                                <label>Meno kravičky</label>
                                                <input type="text" class="form-control" placeholder="Daj meno svojej kravičke" v-model="kravicka_meno" required="">
                                            </div>
                                        </div>
                                        <div class="form-row">
                                            <div class="col-12 col-md-12">
                                                <label>Meno majiteľa kravičky</label>
                                                <input type="text" class="form-control" placeholder="Meno adoptívneho rodiča / kolektívu" v-model="kravicka_meno_rodica" required="">
                                            </div>
                                        </div>
                                        <div class="form-row">
                                            <div class="col-12 col-md-12">
                                                <button v-if="kravicka_status == 0" class="btn --primary w-100">
                                                    Pokračovať ďalej<span class="icon --angleIcon"></span>
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                    <!-- .Form Box -->

                                </div>

                                <!-- Benefity -->
                                <div class="col-lg-5 col-xl-5">
                                    <aside class="o-widget mb-md-5">
                                        <div class="m-widgetContent">
                                            <div class="m-widgetContent__description">
                                                <p>Daj meno svojej kravičke a vyplň aj svoje meno, alebo meno koho bude kravička po adopcii, alebo názov triedy - kolektívu kto si kravičku adoptuje. Meno kravičky aj meno majiteľa kravičky bude potom uvedené na Rodnom liste kravičky.</p>
                                            </div>

                                            <dl>
                                                <dt>Číslo kravičky</dt>
                                                <dd>{{ kravicka_cislo }}</dd>
                                                <dt>Farma</dt>
                                                <dd>{{ kravicka_dvor }}</dd>
                                                <dt>Dátum narodenia</dt>
                                                <dd class="mb-0">{{ kravicka_datum | moment('D.M.YYYY') }}</dd>
                                            </dl>
                                        </div>
                                    </aside>
                                </div>
                                <!-- .Benefity -->

                            </div>
                        </div>
                    </div>
                    <!-- .Adopcia -->

                </div>
            </div>
        </main>
        <!-- .Main -->

    </div>
</template>



<script>
    import EventService from '@/services/EventService.js'
    import HeaderProfil from '../partials/HeaderProfil.vue'
    export default {
        components: {
            HeaderProfil
        },
        props: [
            'profil'
        ],
        mounted() {
            this.getKravickaId()
            this.getKravickaInfo()
        },
        data() {
            return {
                kravicka_id: '',

                kravicka_meno: '',
                kravicka_meno_rodica: '',
                kravicka_cislo: '',
                kravicka_dvor: '',
                kravicka_datum: '',
                kravicka_status: '',
                kravicka_img_hlava: '',

                responseType: '',
                responseText: ''
            }
        },
        methods: {
            // emit
            emitUpdateProfil() {
                this.$emit('updateProfil')
            },


            // mounted
            getKravickaId() {
                if ( this.$route.params.kravicka_id ) {
                    this.kravicka_id = this.$route.params.kravicka_id
                    sessionStorage.setItem("kravickaId", this.$route.params.kravicka_id)
                } else {
                    this.kravicka_id = sessionStorage.getItem("kravickaId")
                }

                if ( !this.kravicka_id ) {
                    this.$router.push({ name: 'login' })
                }
            },

            getKravickaInfo() {
                EventService.getKravickaInfo(this.$route.params.kravicka_id)
                    .then(response => {
                        //console.log(response.data)
                        // fix ak príde response s chybovou hláškou (Undefined index: ean_kravicky)
                        /*if (typeof(response.data) == 'string') {
                            var toj = response.data.split("<br />")
                            var obj = JSON.parse(toj[0])
                            console.log(obj.data[0])
                            response.data = obj
                        }*/
                        this.kravicka_cislo     = response.data.data.kravicka_regcislo
                        this.kravicka_dvor      = response.data.data.dvor_nazov
                        this.kravicka_datum     = response.data.data.kravicka_datum_nar
                        this.kravicka_status    = parseInt(response.data.data.kravicka_status)
                        this.kravicka_img_hlava = response.data.data.kravicka_img_hlava

                        if (parseInt(response.data.data.kravicka_status) == 1) {
                            this.responseType = 'warning'
                            this.responseText = 'Kravička je rezervovaná'
                        } else if (parseInt(response.data.data.kravicka_status) == 2) {
                            this.responseType = 'warning'
                            this.responseText = 'Kravička je už adoptovaná'
                        }
                    })
                    .catch(error => {
                        this.responseType = 'warning'
                        this.responseText = error
                    })
            },


            // submit
            formSubmit(e) {
                e.preventDefault()
                this.setKravickaAdopcia()
            },

            setKravickaAdopcia() {
                EventService.setKravickaAdopcia(this.$route.params.kravicka_id, this.kravicka_meno, this.kravicka_meno_rodica, this.profil.pouzivatel_id.id, this.profil.id)
                    .then(response => {
                        //console.log(response.data)
                        if (response.status == 200) {
                            if (response.data.code == 'danger') {
                                this.responseType = 'danger'
                                this.responseText = response.data.data
                            } else {
                            	sessionStorage.removeItem("kravickaId")

                                var nova_kravicka = {
                                    dvor_id: {
                                        dvor_nazov: this.kravicka_dvor
                                    },
                                    farma_kravicka: {
                                    },
                                    id: this.$route.params.kravicka_id,
                                    kravicka_img_hlava: this.kravicka_img_hlava,
                                    kravicka_meno: this.kravicka_meno,
                                    kravicka_meno_rodica: this.kravicka_meno_rodica,
                                    kravicka_param_cistota: 0,
                                    kravicka_param_global: 0,
                                    kravicka_param_jedlo: 0,
                                    kravicka_param_pitie: 0,
                                    kravicka_param_zabava: 0,
                                    kravicka_pozadie_profil: null,
                                    kravicka_status: 1
                                }
                                this.profil.pouzivatel_id.kravicky_pouzivatela.push(nova_kravicka)
                                this.$emit('update:profil', this.profil)

                                this.$router.push({ 
                                    name: 'adopcia-ean', 
                                    params: { kravicka_id: this.$route.params.kravicka_id }
                                })
                            }

                        } else {
                            this.responseType = 'danger'
                            this.responseText = response.status
                        }
                    })
                    .catch(error => {
                        this.responseType = 'warning'
                        this.responseText = error
                    })
            }
        }
    }
</script>